<div *ngIf="record">
  <h2> {{ record['name'] }} </h2>
  <div style="text-align: left;">
    <a routerLink="/training" >返回</a>
  </div>
  <hr>
  <div style="overflow-x:auto;">
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col" *ngFor="let heading of record['column_names']" style="min-width: 92px;">
            {{ heading }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor = "let data of record['data']">
          <td *ngFor = "let heading of record['column_names']">
            <span *ngIf='!isObject(data[heading])'> {{ data[heading] }} </span>
            <span *ngIf='isObject(data[heading])'> {{ data[heading].toDate() | date }} </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<p *ngIf="!record"> 尋找中 ... </p>
